import {
  useObservationLogsExport,
  UseObservationLogsSearchParams,
} from '@/hooks'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'
import { LoadingButton } from '@mui/lab'

export type ObservationLogsExportProps = {
  filterParams: UseObservationLogsSearchParams
}

export const ObservationLogsExport = ({
  filterParams,
}: ObservationLogsExportProps) => {
  const { t } = useTranslation('common')
  const { enqueueSnackbar } = useSnackbar()

  const { doExport, loading: isExportInProcess } = useObservationLogsExport()

  const handleExportSubmit = async () => {
    try {
      await doExport(filterParams)

      enqueueSnackbar(t('messages.exportedSuccessfully'), {
        variant: 'success',
      })
    } catch (e) {
      enqueueSnackbar(`${t('errors:api.execute')}: ${e}`, {
        variant: 'error',
      })
    }
  }

  return (
    <LoadingButton
      variant="contained"
      color="secondary"
      loading={isExportInProcess}
      disableElevation={true}
      disabled={isExportInProcess}
      onClick={handleExportSubmit}
    >
      <span> {t('buttons.export')}</span>
    </LoadingButton>
  )
}
